import { FeatureFlag } from '../FeatureFlag';

export const useAlphaEyeHoldersTab = new FeatureFlag({
    key: 'use-alpha-eye-holders-tab',
    createdOn: '2026-06-23',
    defaultValue: false,
});
